import { observable, makeAutoObservable } from 'mobx';

export type TranslationTab = 'static-translation' | 'feed-translation';

export class TranslationPageState {
    @observable public selectedPageType: TranslationTab = 'static-translation';

    public selectStaticTranslation = (): void => {
        this.selectedPageType = 'static-translation';
    };

    public selectFeedTranslation = (): void => {
        this.selectedPageType = 'feed-translation';
    };

    constructor() {
        makeAutoObservable(this);
    }
}
